import { useClientValueHistory } from "@/lib/hooks/use-client-detail";
import { TotalValueCardView } from "./total-value-card-view";

type TotalValueCardProps = {
  clientId: string;
};

/**
 * The client's total value week by week, summed over the accounts the bank
 * sends value history for and converted to the tenant currency server-side
 * (QL-356). Renders nothing until there is at least one point, so a client
 * without history sees the Accounts tab exactly as before.
 */
export function TotalValueCard({ clientId }: TotalValueCardProps) {
  const { history } = useClientValueHistory(clientId);
  if (!history || history.points.length === 0 || !history.latest) return null;
  return <TotalValueCardView history={history} />;
}
